import sendRequest from "@/libs/sendRequest"

export const supervisions = {
    namespaced: true,
    state: {
        supervision: null,
        supervisions: null,
        error: null,
        fake_list: {
            success: true,
            data: [
                {
                    id: 1,
                    client: "09871425300",
                    store_name: "Las cuquitas",
                    route: 'Zona1Y Izcalli',
                    assesor_name: 'Jorge Luis Pérez',
                    last_visit: '16 / AGO /2025',
                    status: 'process'
                }
            ]
        }
    },
    getters: {
        getsupervision: (state) => (state.supervision),
        getSupervisions: (state) => (state.supervisions),
        getError: (state) => (state.error)
    },
    mutations: {
        setSupervision: (state, payload) => state.supervision = payload,
        setSupervisions: (state, payload) => state.supervisions = payload,
        setError: (state, payload) => state.error = payload
    },
    actions: {
        list: async({state, commit, dispatch, rootGetters }, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            // const response = await sendRequest('administrator/supervisions/list', 'GET', null, null, null, custom_headers)
            const response = state.fake_list

            if(response.success && response.data) {
                commit('setSupervisions', response.data)
                dispatch('hiddenLoading', null, { root: true })
                console.log(state.supervisions)
                // if(query.paginate) {
                //     commit('setTotalPages', response.data.pagination.totalPages)
                // }
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', errorHandling('clients', response.errors), { root: true })
            }
            else if(!response.success && !response.errors) {
                dispatch('lostConection', null, { root: true })
            }
        },
        view: async({ state, commit, rootGetters }, query) => {
            const custom_headers = rootGetters.getHeaders
            // const response = await sendRequest('administrator/supervisions/view', 'GET', null, null, query, custom_headers)
            let item = state.fake_list.data.clients.find(item => item.id === query.id)
            const response = {
                "success": true,
                "data": item
            }

            if(response.success && response.data) {
                commit('setSupervision', response.data ?? null)
            }
            else if(!response.success && response.errors) {}
        },
        add: async({ commit, rootGetters }, body) => {
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('administrator/supervisions/add', 'POST', null, body, null, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Supervision guardada con éxito', { root: true })
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                let messages = []

                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_values':
                            messages.push('Error: Los valores no han sido ingresados')
                            break;
                        default:
                            messages.push('Un error ha ocurrido intente más tarde')
                            return;
                    }
                }

                dispatch('showError', messages, { root: true })
            }
            else if(response.success && !response.data) {
                dispatch('showError', 'Ha ocurrido un error de conexión intente más tarde', { root: true })
            }
        },
        update: async({ commit, rootGetters }, body) => {
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('administrator/supervisions/update', 'PUT', null, body, null, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Supervision actualizada con éxito', { root: true })
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                let messages = []

                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_values':
                            messages.push('Error: Los valores no han sido ingresados')
                            break;
                        default:
                            messages.push('Un error ha ocurrido intente más tarde')
                            return;
                    }
                }

                dispatch('showError', messages, { root: true })
            }
            else if(response.success && !response.data) {
                dispatch('showError', 'Ha ocurrido un error de conexión intente más tarde', { root: true })
            }
        },
        inactive: async({ commit, rootGetters }, id) => {
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('administrator/banners/active', 'PUT', null, null, { id: id}, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Supervision borrada con éxito', { root: true })
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                dispatch('showError', 'Un error ha ocurrido intente más tarde', { root: true })
            }
            else if(response.success && response.data) {
                dispatch('showError', 'Ha ocurrido un error de conexión intente más tarde', { root: true })
            }
        }
    }
}